const PREFIX = 'top-nav';

export const TEST_ID = {
  TOP_NAV_AVATAR_MENU: `${PREFIX}.avatar-menu`,
  TOP_NAV_HOME_BUTTON: `${PREFIX}.home-button`,
  TOP_NAV_LOGOUT: `${PREFIX}.logout`,
  TOP_NAV_COLOR_SCHEME_TOGGLE: `${PREFIX}.color-scheme-toggle`,
};
